import { createFileRoute, Link } from "@tanstack/react-router";
import { RANKINGS } from "@/lib/rankings-config";
import { breadcrumbLd, itemListLd, SITE_OG_IMAGE } from "@/lib/seo";

const DESC =
  "EPA-based fuel economy rankings: best gas mileage SUVs, trucks, cars, minivans, hybrids and EVs, plus lowest annual fuel cost and emissions.";

export const Route = createFileRoute("/best/")({
  head: () => ({
    meta: [
      { title: "Best Gas Mileage Rankings by Vehicle Type | AutoSpecData" },
      { name: "description", content: DESC },
      { property: "og:title", content: "Best Gas Mileage Rankings by Vehicle Type" },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "https://autospecdata.com/best" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: SITE_OG_IMAGE },
      { name: "twitter:image", content: SITE_OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: "https://autospecdata.com/best" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          itemListLd(
            "Vehicle efficiency rankings",
            RANKINGS.map((r) => ({ name: r.h1, path: `/best/${r.slug}` })),
          ),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbLd([
            { name: "Home", path: "/" },
            { name: "Rankings", path: "/best" },
          ]),
        ),
      },
    ],
  }),
  component: RankingsIndex,
});

function RankingsIndex() {
  return (
    <div>
      <nav className="mx-auto max-w-5xl px-4 sm:px-6 pt-4 text-sm text-muted-foreground">
        <Link to="/" className="hover:text-foreground">
          Home
        </Link>
        <span className="mx-2">/</span>
        <span className="text-foreground">Rankings</span>
      </nav>
      <section className="border-b border-border bg-gradient-to-b from-secondary/40 to-background">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 py-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-foreground">
            Best Gas Mileage Rankings
          </h1>
          <p data-quick-answer className="mt-4 max-w-3xl text-base leading-relaxed text-foreground">
            {DESC}
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-5xl px-4 sm:px-6 py-8">
        <div className="grid gap-4 sm:grid-cols-2">
          {RANKINGS.map((r) => (
            <Link
              key={r.slug}
              to="/best/$slug"
              params={{ slug: r.slug }}
              className="rounded-lg border border-border bg-card p-5 transition-colors hover:border-primary"
            >
              <h2 className="font-bold text-foreground">{r.h1}</h2>
              <p className="mt-1 text-sm text-muted-foreground">{r.description}</p>
              <span className="mt-3 inline-block text-xs uppercase tracking-wide text-primary">
                Ranked by {r.metricLabel}
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
